import React, { forwardRef, useMemo, useState } from 'react';

interface PictureProps {
  src: string;
  srcset: string;
  viewWidth?: string;
  id?: string;
  style?: React.CSSProperties;
  className?: string;
  alt?: string;
  link?: string;
  target?: string;
}

const Picture = ({ src, srcset, viewWidth, id, style, className, alt, link = '', target = '' }: PictureProps, ref: any) => {
  const [showCompressed, setShowCompressed] = useState(true);
  const srcSetStr = useMemo(() => {
    const eventAndFilenameRegex = /\/files\/(\d+)\/(.*$)\?*/gi;
    const matches = eventAndFilenameRegex.exec(src);
    if (!srcset && matches?.length > 1) {
      const eventId = matches[1];
      const filename = matches[2];
      const fileExtension = filename.slice(filename.lastIndexOf('.'));
      const srcSetArr: string[] = [];
      const sizes = [50, 320, 768, 1280, 1920];
      for (let i = 0; i < sizes.length; i++) {
        const size = sizes[i];
        srcSetArr.push(
          `https://jirangopub.s3.eu-north-1.amazonaws.com/CompressedFiles/${eventId}/${encodeURIComponent(
            filename.replace('.', '-').toLowerCase()
          )}/${encodeURIComponent(filename.replace(fileExtension, ''))}-${size}.webp ${size}w`
        );
      }
      return srcSetArr.join(', ');
    }
    return srcset;
  }, [srcset, src]);
  if (link && link !== 'https://' && link !== '123') {
    return (
      <a href={link.startsWith('http') ? link : `https://${link}`} target={target ? target : '_self'}>
        <picture>
          {showCompressed ? <source type={'image/webp'} srcSet={srcSetStr} sizes={viewWidth ?? '100vw'} /> : null}
          <img src={src} id={id} ref={ref} style={style} className={className} alt={alt} onError={() => setShowCompressed(false)} />
        </picture>
      </a>
    );
  }
  return (
    <picture>
      {showCompressed ? <source type={'image/webp'} srcSet={srcSetStr} sizes={viewWidth ?? '100vw'} /> : null}
      <img src={src} id={id} ref={ref} style={style} className={className} alt={alt} onError={() => setShowCompressed(false)} />
    </picture>
  );
};
export default forwardRef(Picture);
